const surfGreen300Color = '#bbd3cb';

export default surfGreen300Color;
